module.exports = __webpack_public_path__ + "img/prometheus-Logo.aa77127f.svg";